<template>

    <v-modal
        :open="open"
        class="c-modal_ext_office">
        <h2>Pobieranie placówek z portalu </h2>
        <p class="c-modal_ext_office__content">Wykonanie tej akcji spowoduje zsynchronizowanie placówek z portalem <a
            href="https://sprawdzonyfizjoterapeuta.pl" target="_blank">sprawdzonyfizjoterapeuta.pl</a>.</p>
        <p class="c-modal_ext_office__question">Czy na pewno chcesz zsynchronizować placówki?</p>
        <div>
            <v-btn
                type="white"
                @click="cancel">
                Anuluj
            </v-btn>
            <v-btn
                type="green"
                @click="ok"
                has-loader
                :loading="isLoading">
                Tak, zsynchronizuj
            </v-btn>
        </div>
    </v-modal>

</template>


<script>

import VModal from 'Components/VModal'
import VBtn from 'Components/VBtn'

export default {

    name: 'PatientRemoveModal',

    data() {
        return {
            patientId: null,
            open: false,
            isLoading: false
        }
    },

    methods: {
        cancel() {
            this.open = false
        },

        ok() {
            this.isLoading = true
            this.$store.dispatch('PHT_EXT_OFFICES_FETCH').then(({data}) => {
                this.isLoading = false
                this.$alert.success('Pobieranie placówek', data.message)
                this.open = false
                this.$emit('success')
            }).catch((error) => {
                this.isLoading = false
                this.$alert.error('Pobieranie placówek', error.response.data.message)
                this.open = false
                this.$emit('failure')
            })
        },
    },

    mounted() {
        this.$on('open', (id) => {
            this.patientId = id
            this.open = true
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        VModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_ext_office {
    text-align: center;

    &__content {
        margin: 1.5rem 0;
    }
    &__question {
        color: $c-primary;
        font-weight: 800;
        margin-bottom: 2rem;
    }
    button {
        margin: .5rem;
    }
}

</style>
